import * as types from "../../actions/actionTypes"
const initialState = {
    loading:true,
    error:false,
    data: { data: [], links: {}, message: [], meta: {}, chart_data:[] }
};

const ManagerOverallCost = (state = initialState, action) => {
    switch (action.type) {
        case types.MANAGER_GET_OVERALL_COST_REQUEST:
            return { ...state, loading: true, error: false };
        case types.MANAGER_GET_OVERALL_COST_SUCCESS:
            return { ...state, loading: false, data: action.payLoad };
        case types.MANAGER_GET_OVERALL_COST_FAILURE:
            return { ...state, loading: false, error: true };
        default:
            return state;
    }
};

export default ManagerOverallCost;